import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import { changeGroupName, groupStackChangeNameBeingEdited } from '../../../../actions'

const mapStateToProps = (state) => {
    const activeGroupId = state.getIn(['ui', 'groupStack', 'activeGroup'])
    const activeGroup = state
        .getIn(['ui', 'entityStack', 'groups', 'groups'])
        .find((group) => _.toString(group.get('id')) === activeGroupId)
    const edited = state.getIn(['ui', 'groupStack', 'groupData', 'nameBeingEdited'], false)

    return { activeGroup, edited }
}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ changeGroupName, groupStackChangeNameBeingEdited }, dispatch)

export default function (GroupNameComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            activeGroup: IPropTypes.map,
            changeGroupName: PropTypes.func.isRequired,
        }

        shouldComponentUpdate(nextProps) {
            const { activeGroup: nextActiveGroup } = nextProps
            const { activeGroup } = this.props

            return !!nextActiveGroup || !!activeGroup || !nextActiveGroup.equal(activeGroup)
        }

        render() {
            const { activeGroup } = this.props

            return activeGroup ? <GroupNameComponent {...this.props} /> : null
        }
    }
    return HocConnect
}
